/**
 * The public site's policy pages, as the app and the API's own pages link to
 * them (g96). Neither knows the site's address: the app's `index.html` is the
 * same in every environment, and no hostname is written in anything that
 * runs. So a link names `via`, a path on the app's own origin, and the API
 * redirects it to `path` on the site (`routes/site-links.ts`).
 */
export interface PolicyPage {
  /** What the link says. */
  label: string;
  /** The link's address, on the app's origin. */
  via: string;
  /** The page's path on the public site. */
  path: string;
}

export const POLICY_PAGES = {
  privacy: { label: "Privacy policy", via: "/api/site/privacy", path: "/privacy/" },
  terms: { label: "Terms of use", via: "/api/site/terms", path: "/terms/" },
} as const satisfies Record<string, PolicyPage>;

export type PolicyPageName = keyof typeof POLICY_PAGES;
